export const idLivelloContrattuale = {
  livelloUnico: 0,
  livelloA: 1,
  livelloAs: 2,
  livelloB: 3,
  livelloBs: 4,
  livelloCs: 6,
  livelloDs: 8,
};